/* Shop-Kollektion (sections/kjxs-collection.liquid). Kacheln und das Auswahlfenster „Filter“
   schreiben in denselben Zustand: avail (''=lieferbar | pre | all), price ('min-max' in Cent),
   serie, line (Tags), sort ('' neu | best | price | price-desc). Alle Karten liegen im Raster;
   sichtbar sind die Treffer in Portionen. „Bestseller“ holt die Reihenfolge einmalig über die
   Section-Rendering-API mit sort_by=best-selling. ?serie=… wählt eine Serie vor. */
(function () {
  'use strict';

  function init(root) {
    if (root._kjxs) return;
    root._kjxs = true;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
    var grid = $('[data-kjxs-grid]');
    var bar = $('[data-kjxs-bar]');
    var more = $('[data-kjxs-more]');
    var empty = $('[data-kjxs-empty]');
    var countEl = $('[data-kjxs-count]');
    var fn = $('[data-kjxs-fn]');
    var go = $('[data-kjxs-go]');
    var page = parseInt(root.getAttribute('data-page'), 10) || 24;
    var one = root.getAttribute('data-unit-one') || 'Produkt';
    var many = root.getAttribute('data-unit-many') || 'Produkte';
    var items = [].slice.call(grid.querySelectorAll('.kjxs-item'));
    var best = null;
    var limit = page;
    var state = { avail: '', price: '', serie: '', line: '', sort: '' };
    var tileKey = root.getAttribute('data-tile-group') === 'line' ? 'line' : 'serie';
    var otherKey = tileKey === 'line' ? 'serie' : 'line';

    function num(el, k) { return parseFloat(el.getAttribute('data-' + k)) || 0; }
    function has(el, tag) { return (el.getAttribute('data-f') || '').indexOf('|' + tag + '|') !== -1; }
    function match(el) {
      var av = el.getAttribute('data-av') === '1';
      if (state.avail === '' && !av) return false;
      if (state.avail === 'pre' && (!av || el.getAttribute('data-pre') !== '1')) return false;
      if (state.serie && !has(el, state.serie)) return false;
      if (state.line && !has(el, state.line)) return false;
      if (state.price) {
        var r = state.price.split('-'), p = num(el, 'price');
        if (p < +r[0] || p > +r[1]) return false;
      }
      return true;
    }
    function units(n) { return n + ' ' + (n === 1 ? one : many); }

    function render() {
      var list = items.slice().sort(function (a, b) {
        // Ausverkaufte immer ans Ende
        var d = num(b, 'av') - num(a, 'av');
        if (d) return d;
        switch (state.sort) {
          case 'price': return num(a, 'price') - num(b, 'price');
          case 'price-desc': return num(b, 'price') - num(a, 'price');
          case 'best':
            if (best) {
              var ra = best[a.getAttribute('data-id')], rb = best[b.getAttribute('data-id')];
              return (ra == null ? 1e6 : ra) - (rb == null ? 1e6 : rb);
            }
            return num(a, 'idx') - num(b, 'idx');
          default: return num(b, 'pub') - num(a, 'pub') || num(a, 'idx') - num(b, 'idx');
        }
      });
      var hits = 0;
      list.forEach(function (el) {
        var ok = match(el);
        if (ok) hits++;
        el.hidden = !ok || hits > limit;
        grid.appendChild(el);
      });
      if (more) {
        more.hidden = hits <= limit;
        more.textContent = 'Mehr laden (' + (hits - Math.min(hits, limit)) + ' weitere)';
      }
      if (empty) empty.hidden = hits > 0;
      if (countEl) countEl.textContent = units(hits);
      if (go) go.textContent = hits ? units(hits) + ' anzeigen' : 'Keine Treffer';
      sync();
    }

    function sync() {
      var onlyTile = !state[otherKey] && !state.price && !state.avail;
      $$('[data-tile]').forEach(function (t) {
        var v = t.getAttribute('data-tile');
        var on = onlyTile && v === state[tileKey];
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-group]').forEach(function (g) {
        var key = g.getAttribute('data-group');
        [].forEach.call(g.querySelectorAll('[data-v]'), function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-v') === state[key] ? 'true' : 'false');
        });
      });
      var n = ['avail', 'price', 'serie', 'line'].filter(function (k) { return state[k]; }).length;
      if (fn) { fn.hidden = !n; fn.textContent = n; }
    }

    function apply() { limit = page; render(); }

    function loadBest() {
      if (best) return Promise.resolve();
      var url = (root.getAttribute('data-url') || location.pathname) + '?sort_by=best-selling&section_id=' + encodeURIComponent(root.getAttribute('data-section-id'));
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var ids = html.match(/data-id="\d+"/g) || [];
        best = {};
        ids.forEach(function (m, i) { var id = m.slice(9, -1); if (!(id in best)) best[id] = i; });
      }).catch(function () { best = {}; });
    }

    // Kacheln: Tipp filtert, Strg/Cmd-Klick öffnet den Link
    $$('[data-tile]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        state[tileKey] = t.getAttribute('data-tile');
        state[otherKey] = ''; state.price = ''; state.avail = '';
        apply();
      });
    });

    var lastFocus = null;
    function openSheet(name) {
      var s = $('[data-kjxs-sheet="' + name + '"]');
      if (!s) return;
      lastFocus = document.activeElement;
      s.hidden = false;
      document.documentElement.classList.add('kjxc-lock');
      var f = s.querySelector('[aria-pressed="true"]') || s.querySelector('button');
      if (f) f.focus({ preventScroll: true });
    }
    function closeSheets() {
      $$('[data-kjxs-sheet]').forEach(function (s) { s.hidden = true; });
      document.documentElement.classList.remove('kjxc-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    $$('[data-open]').forEach(function (b) { b.addEventListener('click', function () { openSheet(b.getAttribute('data-open')); }); });
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-group] [data-v]');
      if (opt) {
        var key = opt.closest('[data-group]').getAttribute('data-group');
        state[key] = opt.getAttribute('data-v');
        if (key === 'sort') {
          closeSheets();
          if (state.sort === 'best') { loadBest().then(apply); return; }
        }
        apply();
        return;
      }
      if (e.target.closest('[data-kjxs-reset]')) { state.avail = ''; state.price = ''; state.serie = ''; state.line = ''; apply(); return; }
      if (e.target.closest('[data-close]')) closeSheets();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });
    if (more) more.addEventListener('click', function () { limit += page; render(); });

    // Leiste unter den Theme-Header schieben (wie auf der Kuji-Seite)
    var header = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    function place() {
      var top = 0;
      if (header) {
        var r = header.getBoundingClientRect();
        var pos = getComputedStyle(header).position;
        if ((pos === 'sticky' || pos === 'fixed' || header.classList.contains('shopify-section-header-sticky')) && r.bottom > 0) top = Math.round(r.bottom);
      }
      root.style.setProperty('--kjxc-top', top + 'px');
      if (bar) bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1 && window.pageYOffset > 0);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; place(); });
    }, { passive: true });
    window.addEventListener('resize', place);
    place();

    var pre = '';
    try { pre = new URLSearchParams(location.search).get('serie') || ''; } catch (e) {}
    if (pre && root.querySelector('[data-group="serie"] [data-v="' + (window.CSS && CSS.escape ? CSS.escape(pre) : pre) + '"]')) state.serie = pre;
    apply();
  }

  function boot() { document.querySelectorAll('[data-kjxs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
